module.exports = __webpack_public_path__ + "img/168.04151d4b.png";